import { User } from "../interfaces/UserInterface";
import { http, httpForm } from "../utils/http-common";
import { useMainStore } from "@/store/main.store";

const logoUrlCache = new Map<string, { url: string; expiresAt: number }>();

export function getCompanyUsers() {
  return http
    .get("/users")
    .then((res) => {
      return res.data.data;
    })
    .catch((err) => {
      console.log(err);
    });
}
export function getUserById(id: string) {
  return http.get(`/users/${id}`);
}
export function getUserByUUID(uuid: string) {
  return http.get(`/users/uuid/${uuid}`).then((res) => res.data.data);
}
export function getAllUsers(superAdminToken?: string) {
  return http.get("/users/all", { headers: { superAdminToken: superAdminToken ?? "" } }).then((res) => res.data.data);
}

export function createNewUserWithObject(user: User) {
  delete user.companyId;
  delete user.credentialsId;

  return http.post("/users", user).then((res) => {
    return res.data;
  });
}

export function createNewUser(name: string, surname: string, email: string, credentialsId?: number) {
  return http.post(`/users`, {
    credentialsId: credentialsId,
    email: email,
    name: name,
    surname: surname,
  });
}

export function updateUser(userId: number, user: User) {
  const { companyId, credentialsId, uuid, id, createdAt, updatedAt, ...rest } = user;

  delete rest.address?.id;
  delete rest.address?.createdAt;
  delete rest.address?.updatedAt;

  return http.put(`/users/${userId}`, rest).then((res) => res.data.data);
}

export function deleteUser(userId: number) {
  return http.delete(`/users/${userId}`).then((res) => {
    return res.data;
  });
}

export function getUserFromToken() {
  return http.get(`/currentUser`).then((res) => res.data.user);
}

export async function getMyUserLogo(size: "large" | "small"): Promise<string> {
  const mainStore = useMainStore();
  const companyId = mainStore.user.companyId;
  const userId = mainStore.user.id;
  if (!userId || !companyId) return "";
  return getUserLogo(userId, companyId, size);
}

export async function getUserLogo(id: number | string, companyId: string, size: "large" | "small", options?: { bypassCache?: boolean }): Promise<string> {
  const cacheKey = `${companyId}-${id}-${size}`;
  if (!options?.bypassCache) {
    const cached = logoUrlCache.get(cacheKey);
    if (cached && cached.expiresAt > Date.now() + 60_000) return cached.url;
  }

  const endpoint = String(id) === String(useMainStore().user?.id) ? `/currentUser/logo?size=${size}` : `/user/${id}/logo?size=${size}`;
  try {
    const res = await http.get(endpoint);
    if (!res.data?.url) return "";
    logoUrlCache.set(cacheKey, { url: res.data.url, expiresAt: res.data.expiresAt });
    return res.data.url;
  } catch {
    return "";
  }
}

export async function uploadUserLogo(file: any) {
  const mainStore = useMainStore();
  const formData = new FormData();
  formData.append("file", file);
  const response = await httpForm.postForm(`/currentUser/uploadLogo`, formData);
  invalidateUserLogoCache(mainStore.user.companyId, mainStore.user.id);
  return response;
}

export function invalidateUserLogoCache(companyId?: string, userId?: number | string) {
  for (const key of [...logoUrlCache.keys()]) {
    if (userId && companyId) {
      if (key === `${companyId}-${userId}-large` || key === `${companyId}-${userId}-small`) {
        logoUrlCache.delete(key);
      }
    } else if (companyId && key.startsWith(`${companyId}-`)) {
      logoUrlCache.delete(key);
    } else if (!companyId && !userId) {
      logoUrlCache.delete(key);
    }
  }
}
